import { Text } from "@fragments";

const MONTHS = [
  "jan",
  "fev",
  "mar",
  "abr",
  "mai",
  "jun",
  "jul",
  "ago",
  "set",
  "out",
  "nov",
  "dez",
];

function formatJoinedDate(raw) {
  if (!raw) return null;
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return null;
  const day = String(date.getDate()).padStart(2, "0");
  const month = MONTHS[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}

export default function MemberSinceCell({ member }) {
  const joined = member?.timestamps?.joined || member?.timestamps?.created;
  const formatted = formatJoinedDate(joined);

  return (
    <Text.span contrast={4}>
      {formatted || "—"}
    </Text.span>
  );
}
